'use client';
import { Typography } from '@mui/material';
import SelectionCardProps from './selection-card.interfaces';
import { Card, IconContainer, BodyContainer } from './selection-card.styles';

const SelectionCard = (props: SelectionCardProps): JSX.Element => {
  const { title, body, icon, size = 'medium', disabled, className, variant = 'outlined', ...rest } = props;
  const hasTitle = title != null;
  const hasIcon = icon != null;
  const hasBody = body != null;

  return (
    <Card className={className} size={size} disabled={disabled} variant={variant} {...rest}>
      {hasTitle && (
        <Typography variant="h3" align="center">
          {title}
        </Typography>
      )}
      {hasIcon && <IconContainer>{icon}</IconContainer>}
      {hasBody && <BodyContainer>{body}</BodyContainer>}
    </Card>
  );
};

export default SelectionCard;
